import React from 'react'
import Footer from '../Footer'
import EducationCLRHS7 from '../EducationCLRHS7'

function CLRHS7() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS7/>
            <Footer/>
        </div>
    )
}

export default CLRHS7
